var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.writeLayouts),function(writeLayout){return _c('competition-write-link',{key:`competition${writeLayout}`,attrs:{"writeLayout":writeLayout,"competitionData":_vm.competitionData}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }